module.exports = __webpack_public_path__ + "img/facebook.a73fa260.svg";